module.exports = __webpack_public_path__ + "static/media/score-taotao-background.d16994d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dialog/score-taotao-background.png
// module id = 410
// module chunks = 1